// Single place for trending hero timing (used by Hero.js and App.js)
export const HERO_POSTER_DELAY_MS = 2500;   // Show poster first, then start trailer
export const HERO_TRAILER_PLAY_MS = 25000; // Trailer plays this long, then back to poster
export const TRENDING_SLIDE_INTERVAL_MS = 30000; // Time per trending slide (poster + trailer)
